module.exports = __webpack_public_path__ + "img/tongli-content.5c3917db.png";